import React, { useImperativeHandle, useState } from 'react';
import { Card, Form, message } from 'antd';
import RosterGroups from '../../components/RosterGroups/RosterGroups';
import { authService } from '../../../auth/authService';
import { flags } from '../../../featureFlags/flags'; 
import { useFeatureFlags } from '../../../featureFlags';
import courseFormUtils from '../../pages/CourseEditPage/courseFormUtils';
import useSyncObjectRelationships from '../../gql/hooks/useSyncObjectRelationships';
import './styles.less';

const FormSegmentation = ( { form, modifiedCallback, ref } ) => {

    const [ rosterEditEnabled ] = useFeatureFlags( [ flags.ROSTER_EDIT_ENABLED ] );
    const [ groupSegmantationPayload ] = useFeatureFlags( [ flags.SEGMENTATION_CLIENT_MANAGED_ATTRIBUTES_ENABLED ] );
    const [ sync ] = useSyncObjectRelationships();

    const [ resetValue, setResetValue ] = useState( form.getFieldValue( 'segmentIds' ) ?? [] );
    
    useImperativeHandle( ref, () => ( {
        reset() {
            reset();
        },
        isModified() {
            return form.getFieldValue( 'segmentIdsAreModified' );
        },
        async syncData() {
            const syncData = courseFormUtils.getSegmentSyncValues( form );

            if ( syncData ) {
                try {
                    await sync( { variables: { input: syncData } } );
                    courseFormUtils.updateSegmentValues( form, syncData.relatedResourceIds );
                    const newIds = form.getFieldValue( 'segmentIds' );
                    setResetValue( newIds );
                    reset( newIds );
                    return true;
                } catch ( error ) { 
                    console.error( 'Error saving!', error );  
                    message.error( 'Error saving!' );  
                    return false;
                } 
            }
        }
    } ) );
     
    const reset = ( value = resetValue ) => {
        form.setFieldsValue( { segmentIdsAreModified: false } ); 
        form.setFieldsValue( { segmentIdsModified: [] } );
        form.setFieldsValue( { segmentIds: value } );
        modifiedCallback( false );
    };

    const handleChangeSelectedSegmentIds = ( values ) => {
        // check is modifed
        if ( JSON.stringify( values ) !== JSON.stringify( form.getFieldValue( 'segmentIds' ) ) ) {
            form.setFieldsValue( { segmentIdsAreModified: true } ); 
            form.setFieldsValue( { segmentIdsModified: values } ); 
            form.setFieldsValue( { segmentIds: values } );
            modifiedCallback( true );
        } else {
            form.setFieldsValue( { segmentIdsAreModified: false } ); 
            form.setFieldsValue( { segmentIdsModified: [] } ); 
            modifiedCallback( false );
        }
    };

    return (
        <div className="form-item-segmentation">
            <Card title="Segments">
                <Form.Item
                    name={ 'segmentIds' }
                    valuePropName="segmentIds"
                    layout="horizontal"
                >
                    <RosterGroups
                        auth={ authService }
                        form={ form }
                        name='segmentIds'
                        handleSelectCallback={ handleChangeSelectedSegmentIds }
                        personId={ authService.getClaims()?.[ 'person_id' ] }
                        companyId={ authService.getClaims()?.[ 'company_id' ] }
                        groupAttributes={  groupSegmantationPayload === 'true' || groupSegmantationPayload === true
                            ? [ { name: 'client-managed', value: true } ]
                            : undefined
                        }
                        rosterEditButton={ rosterEditEnabled }
                    />
                </Form.Item>
            </Card>
        </div>
    );
};

export default FormSegmentation;
